<template>
  <ViewWrapper headingText="API Requests">
    <ApiRequests></ApiRequests>
  </ViewWrapper>
</template>

<script>
import ViewWrapper from '@/components/ViewWrapper'
import ApiRequests from '@/components/manage/ApiRequests'

export default {
  components: { ViewWrapper, ApiRequests }
}
</script>



// WEBPACK FOOTER //
// src/components/manage/ApiRequestsPage.vue